import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Access from './pages/Access';
import OpenSource from './pages/OpenSource';

const TITLES = {
  '/': 'Meridian — Proprietary HFT on Solana',
  '/access': 'Meridian — Request Lander Access',
  '/opensource': 'Meridian — The Registry',
};

function ScrollAndTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = TITLES[pathname] || TITLES['/'];
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollAndTitle />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/access" element={<Access />} />
        <Route path="/opensource" element={<OpenSource />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
